import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5627f7bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = {
  key: 0,
  class: "report-modal"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "신고", -1 /* HOISTED */))
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "line-info" }
const _hoisted_7 = { class: "reason-selection-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "사유 선택", -1 /* HOISTED */))
const _hoisted_9 = { class: "btns-wrapper" }
const _hoisted_10 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        ($setup.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("header", _hoisted_3, [
                _hoisted_4,
                _createVNode($setup["InlineSvg"], {
                  class: "close-btn",
                  src: require('@/assets/icons/x-icon.svg'),
                  alt: "닫기",
                  onClick: $setup.closeReportModal
                }, null, 8 /* PROPS */, ["src"])
              ]),
              _createElementVNode("section", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", null, _toDisplayString(`신고노선 : ${$props.lineName} ${$props.lineStartTime}`), 1 /* TEXT */),
                  _createElementVNode("p", null, _toDisplayString(`차량정보 : ${$props.busPlateNumber}`), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reportReasons, (reason) => {
                      return (_openBlock(), _createBlock($setup["ReportReasonButton"], {
                        key: reason.code,
                        selected: reason.code === $setup.selectedReason?.code,
                        class: "btn",
                        type: "button",
                        reason: reason,
                        onClick: ($event: any) => ($setup.selectReason(reason))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(reason.name), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "reason", "onClick"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]),
              _createElementVNode("footer", _hoisted_10, [
                _createVNode($setup["BaseButton"], {
                  title: "신고하기",
                  disabled: !$setup.selectedReason,
                  onOnClick: $setup.requestReport
                }, null, 8 /* PROPS */, ["disabled"])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}